import { Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AddressCard } from "./AddressCard";
import { AddressForm } from "./AddressForm";
import { PricingCart } from "../Cart/PricingCart";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchAddressById, fetchAllAddress } from "../../../State/customer/AddressSlice";
import {
  
  Box,
  Button,
  
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import { createOrder } from "../../../State/customer/OrderSlice";
import { Address, AddressRes } from "../../../types/userType";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
export const Checkout = () => {
  const [open, setOpen] = useState(false);
  const {addressId} = useParams();
  const navigate = useNavigate()
  const [selectedAddress, setSelectedAddress] = useState<number | null>(addressId?parseInt(addressId):null);
  const { auth, addresses } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [successMessage, setSuccessMessage] = useState<boolean>(false);

 
  useEffect(() => {
    dispatch(fetchAllAddress());
  
    setOpen(false);
    setTimeout(() => {
      handleClose()
      setSuccessMessage(false);
     },1000)
     if(selectedAddress){
      dispatch(fetchAddressById(selectedAddress))
     }
  }, [successMessage,addresses.isDeleted,selectedAddress]);
  const handleAddressSelection = (addressId: number|undefined) => {
    if(addressId!=undefined){
      setSelectedAddress(addressId);
    navigate(`/checkout/${addressId}`);
    } // Update the URL with the selected address ID
  };
  const  handleCheckout = (addressId:number) => { 
    if(addressId){
      dispatch(createOrder(addressId))
    }else{
      console.log("error: ");
    }
   }

  return (
    // min-h-screen: Makes the element's minimum height 100% of the viewport height.
    <>
      <div className="pt-10 px-5 sm:px-10 md:px-44 lg:px-20  xl:px-60 min-h-screen">
        <div className="space-y-5 lg:space-y-0 lg:grid grid-cols-3 lg:gap-9">
          {/* display address */}
          {/* col-span-2: This class makes the element span 2 out of the total number of columns defined in the parent grid container. in this case we have in total 3 span( 3 equal columns.) */}
          <div className="col-span-2 space-y-5">
            <div className="flex justify-between items-center">
              <h1 className="font-semibold text-2xl ">Please Select Address</h1>
              <Button onClick={handleOpen}>Add New Address</Button>
            </div>

            {(addresses?.addresses || []).length > 0 ? (
              <div className="text-xs font-medium space-y-5">
                <p className="text-xl">Saved Addresses</p>
                <div className="space-y-3">
                  {(addresses.addresses || []).map((item, index) => (
                    item.id !=undefined && (<AddressCard
                      address={item}
                      fullName={auth?.user?.fullName}
                      key={index}
                      selectedAddress={selectedAddress}
                    setSelectedAddress={() => { handleAddressSelection(item.id) }}
                    />)
                  ))}
                </div>
              </div>
            ) : (
              <div>
                <h1 className="text-xl text-bold text-primary">
                  {addresses?.message || "No saved addresses found."}
                </h1>
              </div>
            )}

            <div className="py-4 px-5 rounded-md border">
              <Button onClick={handleOpen}>Add New Address</Button>
            </div>
          </div>
          {/* pricing cart */}
          <div className="">
            <div className="pricing icon w-full">
              <img
                className=""
                src="https://slicedinvoices.com/wp-content/uploads/edd/2016/01/stripe-payment-gateway.jpg"
                alt=""
              />
            </div>
            <div className="border rounded-md ">
              <PricingCart />
             {selectedAddress&&(
               <div className="p-5">
               <Button onClick={() => { handleCheckout(selectedAddress) }} fullWidth variant="contained" sx={{ py: "11px" }}>
                 Checkout
               </Button>
             </div>
             )}
            </div>
          </div>
        </div>
      </div>
      {/* Address add modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {<AddressForm setSuccessMessage={setSuccessMessage} />}
        </Box>
      </Modal>
    </>
  );
};
